import {
    BdsGrid,
    BdsIcon,
    BdsLoadingSpinner,
    BdsTable,
    BdsTableBody,
    BdsTableCell,
    BdsTableHeader,
    BdsTableRow,
    BdsTableTh,
    BdsTooltip,
} from 'blip-ds/dist/blip-ds-react/components';
import { TableRowEmptyState } from 'components/TableRowEmptyState';
import { useTranslation } from 'react-i18next';
import { TicketsInQueueTableProps } from 'typings';

export const TicketsInQueueTable: React.FC<TicketsInQueueTableProps> = ({
    data,
    isLoading,
    botsInfos,
    openSideBar,
}: TicketsInQueueTableProps) => {
    const { t } = useTranslation();
    return (
        <>
            {isLoading ? (
                <BdsGrid xxs="12" alignItems="center" justifyContent="center" height="250px" padding="t-5">
                    <BdsLoadingSpinner />
                </BdsGrid>
            ) : (
                <div className="data-block-table data-block-table--queue">
                    <BdsTable>
                        <BdsTableHeader>
                            <BdsTableRow>
                                <BdsTableTh justifyContent="center">{t('go-personal-table-column-queue-time')}</BdsTableTh>
                                <BdsTableTh justifyContent="left">{t('go-personal-table-column-contact')}</BdsTableTh>
                                <BdsTableTh justifyContent="left">
                                    {t('go-personal-table-column-number-identifier')}
                                </BdsTableTh>
                                <BdsTableTh justifyContent="center">
                                    {t('go-personal-table-column-ticket-number')}
                                </BdsTableTh>
                                <BdsTableTh justifyContent="center">{t('go-personal-table-column-action')}</BdsTableTh>
                            </BdsTableRow>
                        </BdsTableHeader>
                        <BdsTableBody>
                            {data.map(ticket => (
                                <BdsTableRow key={ticket.id}>
                                    <BdsTableCell justifyContent="center">{ticket.queueTime}</BdsTableCell>
                                    <BdsTableCell justifyContent="left">{ticket.customer.name}</BdsTableCell>
                                    <BdsTableCell justifyContent="left">
                                        {botsInfos.find(botInfo => botInfo.transhipmentSkill === ticket.botId)
                                            ?.installationName || null}
                                    </BdsTableCell>
                                    <BdsTableCell justifyContent="center">#{ticket.number}</BdsTableCell>
                                    <BdsTableCell type="custom" justifyContent="center">
                                        <BdsTooltip
                                            position="left-center"
                                            tooltip-text={t('go-personal-tooltip-view-conversation')}
                                        >
                                            <BdsIcon
                                                className="icon-clickable"
                                                name="message-ballon"
                                                size="medium"
                                                onClick={() =>
                                                    openSideBar(ticket.number, ticket.botId, ticket.customer.name)
                                                }
                                            />
                                        </BdsTooltip>
                                    </BdsTableCell>
                                </BdsTableRow>
                            ))}
                        </BdsTableBody>
                    </BdsTable>
                    {data.length === 0 && (
                        <TableRowEmptyState isSearch={false} messageWhenNoItems={t('go-personal-table-empty-state')} />
                    )}
                </div>
            )}
        </>
    );
};
